import PropTypes from 'prop-types'
import { Badge, CardImg, Col, Row, Table } from 'reactstrap'
import StringUtil from 'utils/string-util'

const propTypes = {
  refund: PropTypes.object
}

const CustomerRefundItemView = ({ refund }) => (
  <>
    <div className='d-flex justify-content-between align-items-center mb-2'>
      <h3>
        <span className='mr-3'>{ refund?.product?.name }</span>
      </h3>
    </div>

    <Row>
      <Col md='4' className='d-flex align-items-center'>
        <div className='mb-2 text-center'>
          <CardImg src={ refund?.product?.image } alt={ refund?.product?.name } />
          <b>{ refund?.product?.sku }</b>
        </div>
      </Col>

      <Col md='8'>
        <Table bordered hover className='mb-0'>
          <tbody>
            <tr>
              <th scope='row'>Number</th>
              <td>{ refund.number }</td>
            </tr>
            <tr>
              <th scope='row'>Quantity</th>
              <td>{ refund.quantity }</td>
            </tr>
            <tr>
              <th scope='row'>Status Note</th>
              <td className='text-wrap'>{ StringUtil.humanize(refund.status_note) }</td>
            </tr>
            <tr>
              <th scope='row'>Resolution Action</th>
              <td><Badge color='primary' pill>{ StringUtil.humanize(refund.resolution_action) }</Badge></td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  </>
)

CustomerRefundItemView.propTypes = propTypes

export default CustomerRefundItemView
